import React from 'react';
import {Alert, Box, Grid, Typography} from "@mui/material";
import { OperacionCorporateLendingDetalleFields } from "../types/fields";
import {FormOperacionCorporateLendingDetalle, OperacionCorporateLendingDetalle} from "../types/types";
import {dateFormatter} from "../../../../../utils/formatters";

interface CorporateLendingDetalleProps {
  detalle?: FormOperacionCorporateLendingDetalle
}

function CorporateLendingDetalle({ detalle }: CorporateLendingDetalleProps) {
  return (
    <Box>
      <Grid container spacing={2}>
        {
          detalle ?
        <>
        <Grid item xs={12}>
          <Typography variant='body2'>Deudor</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Deudor]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Acreedor</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Acreedor]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Moneda</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Moneda]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Monto</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Monto]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Destino de los Fondos</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Destino]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Plazo de Disponibilidad</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.PlazoDisponibilidad]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Plazo</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Plazo]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Amortización</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Amortizacion]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Comisión por Disponibilidad</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Comision]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Precancelación</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Precancelacion]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Tasa de Interés</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.TasaInteres]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Frecuencia de Pago de Interés</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.FrecuenciaInteres]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Fiador y Avalista</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.FiadorAvalista]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Garantías</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Garantias]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Pagaré</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Pagare]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Covenants</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Covenants]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Ley y Jurisdicción</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCorporateLendingDetalleFields.Ley]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Fecha de Ejecución del Mutuo</Typography>
          <Typography
            variant='body1'
          >{detalle?.[OperacionCorporateLendingDetalleFields.FechaEjecucion] ? dateFormatter.toShortDate(detalle[OperacionCorporateLendingDetalleFields.FechaEjecucion]) : '-'}</Typography>
        </Grid>
        </>
          : <Alert severity='info'>No se encontró detalle para esta operación.</Alert>
        }
      </Grid>
    </Box>
  );
}

export default CorporateLendingDetalle;